export default "__VITE_ASSET__K0eGMbd0__"